import { Component, Input, OnInit } from '@angular/core';
import { NavigationListItem } from './models/navigation-list-item.model';

@Component({
  selector: 'app-navigation-list',
  templateUrl: './navigation-list.component.html',
})
export class NavigationListComponent implements OnInit {
  @Input() navigationListItems = [] as Array<NavigationListItem>;
  currentSection = '';

  prefix = 'navigationList.';

  constructor() {}

  ngOnInit(): void {}

  onSectionChange(sectionId: string) {
    this.currentSection = sectionId;
  }

  scrollTo(section: string) {
    document.querySelector('#' + section)!.scrollIntoView({
      behavior: 'smooth',
      block: 'start',
      inline: 'start',
    });
  }
}
